import { apiGet, apiPost } from "@redriver/cinnamon";

const NAMESPACE = "SHEETS/DUPLICATE_FROM_TEMPLATE";

export const ActionTypes = {
  GetTemplateClients: `${NAMESPACE}/GET_TEMPLATE_CLIENTS`,
  DuplicateSheetFromTemplate: `${NAMESPACE}/DUPLICATE_SHEET_FROM_TEMPLATE`,
};

export const getTemplateClients = (dealerOfficeId) =>
  apiGet(ActionTypes.GetTemplateClients, `lookups/clients`, {
    dealerOfficeId,
    isTemplate: true,
  });

export const duplicateSheetFromTemplate = (templateSheetId, formValues) =>
  apiPost(
    ActionTypes.DuplicateSheetFromTemplate,
    `sheets/${templateSheetId}/duplicate-from-template`,
    formValues,
  );
